import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import RequestCodeForm from './RequestCodeForm'
import ValidateCodeForm from './ValidateCodeForm'
import ResetPasswordForm from './ResetPasswordForm'
import * as FA from 'react-icons/fa'

import {
  Container,
  Title,
  StepRow,
  StepContainer,
  StepCircle,
  StepLabel,
  InfoText
} from './styles'

export default function ForgotPassword () {
  const steps = [
    { number: 1, label: 'Solicitar código',value: 'request_code' },
    { number: 2, label: 'Validar código', value: 'verify_code' },
    { number: 3, label: 'Redefinir senha', value: 'reset_password' }
  ]
  
  const [currentStep, setCurrentStep] = useState (steps[0])
  const [userData, setUserData] = useState (null)
  const [email, setEmail] = useState ('')
  const location = useLocation ()
  const userType = location.state?.userType ?? 'business'
  const navigate = useNavigate ()

  const handleCodeRequested = email => {
    setEmail (email)
    setCurrentStep (steps[1])
  }
  const handleCodeValidated = userData => {
    setUserData (userData)
    setCurrentStep (steps[2])
  }
  const handlePasswordReset = () => navigate ('/login', { replace: true })

  return (
    <Container>
      <Title>Restaurar senha</Title>
      <StepRow>
        {steps.map ((step, index) => (
          <StepContainer key={index}>
            <StepCircle step={step} currentStep={currentStep}>
              {currentStep.number > step.number ? (
                <FA.FaCheck color='#FFFFFF' size={18}/>
              ) : (
                <InfoText>{step.number}</InfoText>
              )}
            </StepCircle>
            <StepLabel>{step.label}</StepLabel>
          </StepContainer>
        ))}
      </StepRow>
      {currentStep.value === 'request_code' && (
        <RequestCodeForm userType={userType} onSubmit={handleCodeRequested}/>
      )}
      {currentStep.value === 'verify_code' && (
        <ValidateCodeForm userType={userType} email={email} onSubmit={handleCodeValidated}/>
      )}
      {currentStep.value === 'reset_password' && (
        <ResetPasswordForm
          userType={userType}
          userData={userData}
          onSubmit={handlePasswordReset}
        />
      )}
    </Container>
  )
}
